import { HssItem } from "./hss-item";

export class HssHeader {
  position: string;
  sequenceNumber = new HssItem("Number");
  base = new HssItem("CrewBase");
  isDeleted = new HssItem("SeqDeletPos");
  div = new HssItem("Division");
  acft = new HssItem("EquipmentGroup");
  empNum = new HssItem("EmployeeNumber");
  addCode = new HssItem("AddReasonCode");
  removeCode = new HssItem("OpenSequenceRemovalCode");
  name = new HssItem("Name");
  isInternational = new HssItem("IntSeq");
  isComplete = new HssItem("Complete");
  inProgress = new HssItem("InProgress");
  isFailedContinuity = new HssItem("FailedCont");
  isBlockedIOE = new HssItem("SeqBlockIOE");
  isSupervisor = new HssItem("Supervisor");
  isCheckAirman = new HssItem("CheckAirman");

  constructor(position: string) {
    this.position = position;
  }
}
